
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


interface Product {
  product_code: string;
  image_url: string;
  title: string;
  search_param: string;
  publish_start_date: string;
  publish_end_date: string;
  active: boolean;
}

@Component({
  selector: 'surf-search-banner',
  templateUrl: './surf-search-banner.component.html',
  styleUrls: ['./surf-search-banner.component.scss']
})
export class SurfSearchBannerComponent {
  productForm: FormGroup;
  products: Product[] =  [
    {
      product_code: 'TOU',
      image_url: 'https://b2b.desertadventures.com/travelbox/background_images/Five_Luxe_Thumbnail.png',
      title: 'General Adult City Tour',
      search_param: 'ITINERARY_NAME~General Adult Tour#DURATION_TYPE~A#DESCRIPTION~Explore culture and arts with our best tour of the capital emirate#DESTINATION_CITY~DXB#DESTINATION_PARENT~Dubai, United Arab Emirates#DEPART_IN_MONTHS~1#ADULT~2#CHILDREN~0#CHILDREN_AGE~0#INFANT~0#INFANT_AGE~0',
      publish_start_date: '2023-10-15',
      publish_end_date: '2026-12-31',
      active: true
    },
    {
      product_code: 'HTL',
      image_url: 'https://b2b.desertadventures.com/travelbox/offers/hotel/02%20MJ%20B2B%20Thumbnails.png',
      title: 'Atlantis The Palm, Dubai',
      search_param: 'HOTEL_NAME~Atlantis, The Palm#DESCRIPTION~Book luxurious apartment hotel accommodations on The Palm#DESTINATION_CITY~DXB#DESTINATION_PARENT~Dubai,United Arab Emirates#NUMBER_OF_NIGHTS~2#DEPART_IN_MONTHS~1#ADULT~2#CHILDREN~0#CHILDREN_AGE~0#INFANT~0#INFANT_AGE~0#NUMBER_OF_ROOM~1',
      publish_start_date: '2023-08-15',
      publish_end_date: '2026-12-31',
      active: true
    },
    {
      product_code: 'HTL',
      image_url: 'https://tbxdev.desertadventures.com/travelbox/tbx_images/accommodation_images/Atlantis_The_Palm/img_2_guest_rooms_rooms_11_06_2013_1284ext.jpg',
      title: '1 Hilton Dubai Palm Jumeirah, Dubai',
      search_param: 'HOTEL_NAME~Hilton Dubai Palm Jumeirah#DESCRIPTION~RC_Test Book our best rates on exceptional contemporary stays#DESTINATION_CITY~DXB#DESTINATION_PARENT~Dubai, United Arab Emirates#NUMBER_OF_NIGHTS~2#DEPART_IN_MONTHS~1#ADULT~2#CHILDREN~1#CHILDREN_AGE~5#INFANT~1#INFANT_AGE~14#NUMBER_OF_ROOM~1',
      publish_start_date: '2023-08-10',
      publish_end_date: '2026-12-31',
      active: true
    },
    {
      product_code: 'TOU',
      image_url: 'https://tbxdev.desertadventures.com/travelbox/tbx_images/accommodation_images/Atlantis__The_Palm/img_7_AlJaddafRotanaSuitespool.jpg',
      title: '6 Dessert Safari BBQ Dinner',
      search_param: 'ITINERARY_NAME~Desata01#DURATION_TYPE~A#DESCRIPTION~Explore culture and arts with our best tour of the capital emirate#DESTINATION_CITY~DXB#DESTINATION_PARENT~Dubai,United Arab Emirates#DEPART_IN_MONTHS~1#ADULT~2#CHILDREN~0#CHILDREN_AGE~0#INFANT~0#INFANT_AGE~0',
      publish_start_date: '2023-08-10',
      publish_end_date: '2026-12-31',
      active: true
    },
    {
      product_code: 'HTL',
      image_url: 'https://tbxdev.desertadventures.com/travelbox/tbx_images/accommodation_images/Atlantis__The_Palm/img_7_AlJaddafRotanaSuitespool.jpg',
      title: '7 Atlantis, The Palm, Dubai',
      search_param: 'HOTEL_NAME~Atlantis, The Palm#DESCRIPTION~Book luxurious apartment hotel accommodations on The Palm#DESTINATION_CITY~DXB#DESTINATION_PARENT~Dubai,United Arab Emirates#NUMBER_OF_NIGHTS~2#DEPART_IN_MONTHS~12#ADULT~2#CHILDREN~1#CHILDREN_AGE~5#INFANT~1#INFANT_AGE~14#NUMBER_OF_ROOM~1',
      publish_start_date: '2023-09-05',
      publish_end_date: '2026-12-31',
      active: true
    },
    {
      product_code: 'HTL',
      image_url: 'https://tbxdev.desertadventures.com/travelbox/tbx_images/accommodation_images/Atlantis__The_Palm/img_10_RamadabyWyndhamDubaiDeira1.jpg',
      title: '8 Al Jaddaf Rotana, Dubai',
      search_param: 'HOTEL_NAME~Al Jaddaf Rotana#DESCRIPTION~Book the most ultra-luxury experiential resort in the world#DESTINATION_CITY~DXB#DESTINATION_PARENT~Dubai, United Arab Emirates#NUMBER_OF_NIGHTS~2#DEPART_IN_MONTHS~1#ADULT~2#CHILDREN~1#CHILDREN_AGE~5#INFANT~1#INFANT_AGE~14#NUMBER_OF_ROOM~1',
      publish_start_date: '2023-08-10',
      publish_end_date: '2026-12-31',
      active: true
    },
    {
      product_code: 'HTL',
      image_url: 'https://tbxdev.desertadventures.com/travelbox/tbx_images/accommodation_images/Atlantis_The_Palm/img_resort_landscape_25_01_2016_6550ext.jpg',
      title: '9 Hampton by Hilton Dubai Al Barsha, Dubai',
      search_param: 'HOTEL_NAME~Hampton by Hilton Dubai Al Barsha#DESCRIPTION~Book our best rates on Dubai’s most luxurious resort suites and villas#DESTINATION_CITY~DXB#DESTINATION_PARENT~Dubai, United Arab Emirates#NUMBER_OF_NIGHTS~2#DEPART_IN_MONTHS~1#ADULT~2#CHILDREN~1#CHILDREN_AGE~5#INFANT~1#INFANT_AGE~14#NUMBER_OF_ROOM~1',
      publish_start_date: '2023-08-10',
      publish_end_date: '2026-12-31',
      active: true
    },
    {
      product_code: 'HTL',
      image_url: 'https://tbxdev.desertadventures.com/travelbox/tbx_images/accommodation_images/Atlantis__The_Palm/img_8_al-jaddaf-rotana-exterior.jpg',
      title: '10 Grand Cosmopolitan Hotel Dubai, Dubai',
      search_param: 'HOTEL_NAME~Grand Cosmopolitan Hotel Dubai#DESCRIPTION~Book unforgettable luxurious stays at this Arabian Palace-inspired resort#DESTINATION_CITY~DXB#DESTINATION_PARENT~Dubai, United Arab Emirates#NUMBER_OF_NIGHTS~2#DEPART_IN_MONTHS~4#ADULT~2#CHILDREN~1#CHILDREN_AGE~5#INFANT~1#INFANT_AGE~14#NUMBER_OF_ROOM~1',
      publish_start_date: '2023-08-10',
      publish_end_date: '2026-12-31',
      active: true
    },
    {
      product_code: 'HTL',
      image_url: 'https://b2b.desertadventures.com/travelbox/offers/hotel/12%20Jumeirah%20Saadiyat%20Island%20Thumbnail.png',
      title: 'Jumeirah at Saadiyat Island Resort, Abu Dhabi',
      search_param: 'HOTEL_NAME~Jumeirah at Saadiyat Island Resort#DESCRIPTION~Get the best rates on an unforgettable Desert Escape#DESTINATION_CITY~AUH#DESTINATION_PARENT~Abu Dhabi, United Arab Emirates#NUMBER_OF_NIGHTS~7#DEPART_IN_MONTHS~1#ADULT~2#CHILDREN~0#CHILDREN_AGE~0#INFANT~0#INFANT_AGE~0#NUMBER_OF_ROOM~1',
      publish_start_date: '2024-04-30',
      publish_end_date: '2026-12-31',
      active: true
    },
    {
      product_code: 'HTL',
      image_url: 'https://b2b.desertadventures.com/images/offers/hotel/04%20MJ%20B2B%20Thumbnails3.png',
      title: '2 Jumeira Rotana Hotel Dubai, Dubai',
      search_param: 'HOTEL_NAME~Jumeira Rotana Hotel Dubai#DESCRIPTION~Book our best rates on exceptional contemporary stays#DESTINATION_CITY~DXB#DESTINATION_PARENT~Dubai, United Arab Emirates#NUMBER_OF_NIGHTS~2#DEPART_IN_MONTHS~1#ADULT~2#CHILDREN~0#CHILDREN_AGE~0#INFANT~0#INFANT_AGE~0#NUMBER_OF_ROOM~1',
      publish_start_date: '2023-08-10',
      publish_end_date: '2026-12-31',
      active: true
    },
    {
      product_code: 'TOU',
      image_url: 'https://b2b.desertadventures.com/images/offers/tour/08%20B2B%20Thumbnail%20Discover%20Abu%20Dhabi.jpg',
      title: '3 Royal Safari with Sahara Experience by Land Cruiser',
      search_param: 'ITINERARY_NAME~Destd01#DURATION_TYPE~A#DESCRIPTION~Explore culture and arts with our best tour of Royal Safari with Sahara Experience by Land Cruiser#DESTINATION_CITY~DXB#DESTINATION_PARENT~Dubai,United Arab Emirates#DEPART_IN_MONTHS~2#ADULT~2#CHILDREN~1#CHILDREN_AGE~9#INFANT~0#INFANT_AGE~0',
      publish_start_date: '2023-09-05',
      publish_end_date: '2026-12-31',
      active: true
    },
    {
      product_code: 'TOU',
      image_url: 'https://b2b.desertadventures.com/images/offers/hotel/04%20MJ%20B2B%20Thumbnails3.png',
      title: '4 Hot Air Excl Small Charter',
      search_param: 'ITINERARY_NAME~Bal03#DURATION_TYPE~A#DESCRIPTION~Hot Air Excl Small Charter with Range Rover Pick Up Pvt Breakfast & Wildlife Drive 1-2 Guest#DESTINATION_CITY~DXB#DESTINATION_PARENT~Dubai,United Arab Emirates#DEPART_IN_MONTHS~1#ADULT~2#CHILDREN~1#CHILDREN_AGE~6#INFANT~1#INFANT_AGE~18',
      publish_start_date: '2023-08-10',
      publish_end_date: '2026-12-31',
      active: true
    }
  ];
  editIndex: number | null = null;

  constructor(private fb: FormBuilder) {
    this.productForm = this.fb.group({
      product_code: ['', Validators.required],
      image_url: ['', Validators.required],
      title: ['', Validators.required],
      search_param: ['', Validators.required],
      publish_start_date: ['', Validators.required],
      publish_end_date: ['', Validators.required],
      active: [false]
    });
  }

  onSubmit() {
    if (this.productForm.invalid) return;
    const product = this.productForm.value;
    if (this.editIndex !== null) {
      this.products[this.editIndex] = product;
      this.editIndex = null;
    } else {
      this.products.push(product);
    }
    this.productForm.reset({ active: false });
  }

  onEdit(index: number) {
    this.productForm.patchValue(this.products[index]);
    this.editIndex = index;
  }

  onCancelEdit() {
    this.productForm.reset({ active: false });
    this.editIndex = null;
  }
  onDelete(index: number) {
    this.products.splice(index, 1);
    if (this.editIndex === index) {
      this.onCancelEdit();
    }
  }

}
